export default __webpack_public_path__ + "static/media/a011-example10.cf26b19b.png";